import { PlatformType, PlatformTypeSchema } from '@reward-platform/shared-schemas'
import { isWhitelabelHost } from './whitelabel'

export const getPlatformTypeForHost = (host?: string): PlatformType => {
  const isWhitelabel = isWhitelabelHost(host)
  return isWhitelabel ? PlatformTypeSchema.Enum.whitelabel : PlatformTypeSchema.Enum.avios
}
